"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _client = require("@apollo/client");

var _client2 = require("@searchkit/client");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Query = _interopRequireDefault(require("./Query"));

var _SearchField = _interopRequireDefault(require("./SearchField"));

var _SearchPagination = _interopRequireDefault(require("./SearchPagination"));

var _SearchResults = _interopRequireDefault(require("./SearchResults"));

var _SearchFacets = _interopRequireDefault(require("./SearchFacets"));

var _SearchSelectedFilters = _interopRequireDefault(require("./SearchSelectedFilters"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var defaultChildren = function defaultChildren(data, loading) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SearchField.default, null), /*#__PURE__*/_react.default.createElement(_SearchFacets.default, {
    data: data,
    loading: loading
  }), /*#__PURE__*/_react.default.createElement(_SearchSelectedFilters.default, {
    data: data,
    loading: loading
  }), /*#__PURE__*/_react.default.createElement(_SearchResults.default, {
    data: data
  }), /*#__PURE__*/_react.default.createElement(_SearchPagination.default, {
    data: data
  }));
};

var SearchKit = function SearchKit(_ref) {
  var query = _ref.query,
      uri = _ref.uri,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
      _ref$useRouting = _ref.useRouting,
      useRouting = _ref$useRouting === void 0 ? true : _ref$useRouting,
      _ref$defaultFilters = _ref.defaultFilters,
      defaultFilters = _ref$defaultFilters === void 0 ? [] : _ref$defaultFilters,
      _ref$defaultQuery = _ref.defaultQuery,
      defaultQuery = _ref$defaultQuery === void 0 ? '' : _ref$defaultQuery,
      children = _ref.children,
      _ref$defaultSorting = _ref.defaultSorting,
      defaultSorting = _ref$defaultSorting === void 0 ? 'relevance' : _ref$defaultSorting;
  var client = (0, _react.useMemo)(function () {
    return new _client.ApolloClient({
      uri: uri,
      cache: new _client.InMemoryCache()
    });
  }, [uri]);
  var skClient = (0, _react.useMemo)(function () {
    var skClient = new _client2.SearchkitClient();
    skClient.updateBaseSearchState({
      filters: defaultFilters,
      query: defaultQuery,
      page: {
        size: pageSize,
        from: 0
      },
      sortBy: defaultSorting
    });
    return skClient;
  }, [useRouting, defaultFilters, defaultQuery, pageSize, defaultSorting]);
  return /*#__PURE__*/_react.default.createElement(_client.ApolloProvider, {
    client: client
  }, /*#__PURE__*/_react.default.createElement(_client2.SearchkitProvider, {
    client: skClient,
    key: "".concat(defaultQuery, "-").concat(defaultFilters.toString())
  }, /*#__PURE__*/_react.default.createElement(_Query.default, {
    query: query,
    useRouting: useRouting
  }, function (data, loading) {
    return children ? children(data, loading) : defaultChildren(data, loading);
  })));
};

SearchKit.propTypes = {
  uri: _propTypes.default.string,
  pageSize: _propTypes.default.number,
  useRouting: _propTypes.default.bool,
  defaultFilters: _propTypes.default.object,
  defaultQuery: _propTypes.default.string,
  defaultSorting: _propTypes.default.string
};
SearchKit.defaultProps = {
  uri: null,
  pageSize: 10,
  useRouting: true,
  defaultFilters: [],
  defaultQuery: '',
  defaultSorting: 'relevance'
};
var _default = SearchKit;
exports.default = _default;